<template>
	<div class="part">
		<el-dialog
		  :title="supplierDetails.name"
		  :visible.sync="supplierVisible"
		  width="300px"
		  :close="handleClose">
		  	<p v-for="item in supplierDetails.supplier">
		  		{{item}}
		  	</p>
		   <span slot="footer" class="dialog-footer">
		    <el-button @click="supplierVisible = false">取 消</el-button>
		  </span>
		</el-dialog>
		<!--零件详情弹出框-->
		<el-dialog
		  :title="dialogDetails.name"
		  :visible.sync="dialogVisible"
		  width="700px"
		  :close="handleClose">
		  <div class="dialogMain cf">
				<div class="fl" style="width: 55%;">
					<dl>
						<dt>零件名称：</dt>
						<dd class="cf">
							{{dialogDetails.name?dialogDetails.name:'暂无名称'}}
						</dd>
					</dl>
					<dl>
						<dt>所属系列：</dt>
						<dd class="cf">
							{{seriesIdtoName(dialogDetails.seriesId)}}
						</dd>
					</dl>
					<dl>
						<dt>零件结构：</dt>
						<dd class="cf">
							{{structureIdtoName(dialogDetails.structureId)}}
						</dd>
					</dl>
					<dl>
						<dt>资源路径：</dt>
						<dd class="cf">
							<input type="" class="input" style="border: none;width: 230px;" v-model="dialogDetails.pakUrl" disabled/>
						</dd>
					</dl>
					<dl>
						<dt>零件缩略图：</dt>
						<dd class="cf">
							<div style="border: 1px solid #ddd; text-align: center; width: 230px;">
								<img :src="dialogDetails.imgUrl" width="100%" alt="暂无缩略图"/>
							</div>
						</dd>
					</dl>
				</div>
				<div class="fr" style="width: 43%;padding-right: 10px;">
					<dl>
						<dt>供应商：</dt>
						<dd class="cf">
							<div style="max-height: 60px;overflow-y: auto;">
								{{supplierIdtoName(dialogDetails.supplierId)}}
							</div>
						</dd>
					</dl>
					<dl>
						<dt>价格：</dt>
						<dd class="cf">
							{{dialogDetails.price?dialogDetails.price+'元':'暂无价格'}}
						</dd>
					</dl>
					<dl>
						<dt>组合尺寸：</dt>
						<dd class="cf">
							<div class="fl" v-for="item,index in dialogDetails.sizeType">
								<span>{{item}}:{{dialogDetails.size.length>index?dialogDetails.size[index]:'0'}}</span>
							    <span v-show="index!=dialogDetails.sizeType.length-1">×</span>
							</div>
						</dd>
					</dl>
					<dl>
						<dt>零件编号：</dt>
						<dd class="cf">
							{{dialogDetails.number?dialogDetails.number:'暂无零件编号'}}
						</dd>
					</dl>
					<dl>
						<dt>购买链接：</dt>
						<dd class="cf">
							{{dialogDetails.purchaseLink?dialogDetails.purchaseLink:'暂无购买链接'}}
						</dd>
					</dl>
					<dl>
						<dt>瓦数：</dt>
						<dd class="cf">
							{{dialogDetails.wattage?dialogDetails.wattage+'W':'暂无瓦数信息'}}
						</dd>
					</dl>
					<dl>
						<dt>创建时间：</dt>
						<dd class="cf">
							{{dataTimeFn(dialogDetails.createTime)}}
						</dd>
					</dl>
					<dl>
						<dt>修改时间：</dt>
						<dd class="cf">
							{{dataTimeFn(dialogDetails.modifyTime)}}
						</dd>
					</dl>
					<dl>
						<dt>产品状态：</dt>
						<dd class="cf">
							{{dialogDetails.status?"上架":"下架"}}
						</dd>
					</dl>
					<dl>
						<dt>描述：</dt>
						<dd class="cf">
							<div>
								{{dialogDetails.description?dialogDetails.description:"暂无描述"}}
							</div>
						</dd>
					</dl>
				</div>
			</div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		  </span>
		</el-dialog>
		<!--零件详情弹出框结束-->
		<!--引用nav组件{导航条}-->
		<navZcy v-bind:num="'2-1'" style="min-width: 1300px;"></navZcy>
		<div class="line"></div>
		<!--编辑、添加框-->
		<div class="main" v-show="handle">
			<!--标题-->
			<div class="top cf">
				<div class="topL fl"><span>{{handleTitle}}</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<!--标题结束-->
			<div class="line"></div>
			<!--标签页-->
			<el-tabs type="border-card" v-model="activeName">
				<el-tab-pane label="上传资源" name="Tab1">
					<div class="containerOuter">
						<div id="container">
        					<el-button type="primary" id="postfiles">上传pak文件</el-button>
        					<span class="el-upload__tip" style="padding-left: 20px;">只能上传pak文件</span>
        				</div>
    					<div id="ossfile" v-show="uploadFlieIsOk">
    						<div>
    							{{dialogData.pakUrlName}}
    							<b class="fr">
    								<span>{{responseData}}</span>
    							</b>
								<div class="progress">
									<div class="progress-bar" style="width: 0%"></div>
								</div>
							</div>
    					</div>
    					<div id="containerImg" style="margin-top: 35px;width: 400px;">
        					<el-button type="primary" id="postImg">上传图片</el-button>
        					<span class="el-upload__tip" style="padding-left: 20px;">只能上传jpg/png文件，且不超过1MB</span>
        				</div>
    					<div class="" v-show="uploadImgIsOk&&!thumbnailShow">
    						<div style="width: 240px;margin-top: 20px;">
    							{{dialogData.imgUrlName}}
    							<b class="fr">
    								<span>{{responseImgData}}</span>
    							</b>
								<div class="progressImg">
									<div class="progressImg-bar" style="width: 0%"></div>
								</div>
							</div>
    					</div>
    					<div class="thumbnail" v-show="thumbnailShow">
    						<img :src="dialogData.imgUrl" height="200px"/>
    					</div>
					</div>
					<div style="text-align: center;padding-top: 30px;padding-bottom: 50px;">
						<el-button @click="back()">取消</el-button>
						<el-button type="primary" @click="handleConfirm()" :loading="loading">保存</el-button>
					</div>
				</el-tab-pane>
				<el-tab-pane label="录入信息" name="Tab2">
					<div class="dialogMain" style="padding: 0 35px;">
						<el-row :gutter="50">
						    <el-col :span="12">
								<dl>
									<dt>上传文件：</dt>
									<dd class="cf">
										<div v-show="dialogData.pakUrl">
											<el-input v-model="dialogData.pakUrlName" disabled></el-input>
										</div>
										<div v-show="!dialogData.pakUrl">
											<el-input placeholder="未上传文件" disabled></el-input>
										</div>
									</dd>
								</dl>
								<dl>
									<dt>上传图片：</dt>
									<dd class="cf">
										<div v-show="dialogData.imgUrl">
											<el-input v-model="dialogData.imgUrlName" disabled></el-input>
										</div>
										<div v-show="!dialogData.imgUrl">
											<el-input placeholder="未上传图片" disabled></el-input>
										</div>
									</dd>
								</dl>
							  	<dl>
									<dt>零件名称：</dt>
									<dd class="cf">
										<el-input placeholder="请输入零件名称" v-model="dialogData.name"></el-input>
									</dd>
								</dl>
								<dl>
									<dt>零件编号：</dt>
									<dd class="cf">
										<el-input v-model="dialogData.number" placeholder="请输入零件编号"></el-input>
									</dd>
								</dl>
							  	<dl>
									<dt>组合尺寸：</dt>
									<dd class="cf">
										<el-row class="sizeType fl">
											<el-col :span="24/dialogData.sizeType.length" v-for="item,index in dialogData.sizeType">
													<el-input  :placeholder="item" type="number" class="inputSmall" :value="dialogData.size[index]"></el-input>
											</el-col>
										</el-row>
										<el-select v-model="dialogData.sizeTypeId" placeholder="尺寸属性" style="width: 120px;float: right;" @change="sizeSelceChangeFn">
											<el-option v-for="item,index in sizeTypeOptions" :key="item.id" :label="item.sizeType.join(' * ')" :value="item.id">
											</el-option>
										</el-select>

									</dd>
								</dl>
								<dl>
									<dt>购买链接：</dt>
									<dd class="cf">
										<el-input v-model="dialogData.purchaseLink" placeholder="请输入购买链接"></el-input>
									</dd>
								</dl>
								<dl>
									<dt>瓦数：</dt>
									<dd class="cf">
										<el-input v-model="dialogData.wattage" type="number" placeholder="瓦数(W)" style="width: 100px;"></el-input>
									</dd>
								</dl>
						    </el-col>
						    <el-col :span="12">
								<dl>
									<dt>供应商：</dt>
									<dd class="cf">
										<el-select
										    v-model="dialogData.supplierId"
										    placeholder="请选择" class="inputWidth">
										    <el-option
										      v-for="item in frimOptions"
										      :key="item.id"
										      :label="item.name"
										      :value="item.id">
										    </el-option>
										  </el-select>
									</dd>
								</dl>
								<dl>
									<dt>零件结构：</dt>
									<dd class="cf">
										<el-select
										    v-model="dialogData.structureId"
										    placeholder="请选择" class="inputWidth">
										    <el-option
										      v-for="item in structureOptions"
										      :key="item.id"
										      :label="item.name"
										      :value="item.id">
										    </el-option>
										  </el-select>
									</dd>
								</dl>
								<dl>
									<dt>价格：</dt>
									<dd class="cf">
										<el-input v-model="dialogData.price" style="width: 120px;" placeholder="请输入价格" type="number"></el-input>
									</dd>
								</dl>
								<dl>
									<dt>状态：</dt>
									<dd class="cf">
										<el-switch v-model="dialogData.status" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
									</dd>
								</dl>
								<dl>
									<dt>描述：</dt>
									<dd class="cf">
										<el-input type="textarea" v-model="dialogData.description" :rows="4" placeholder="描述"></el-input>
									</dd>
								</dl>
						    </el-col>
						</el-row>
					</div>
					<div class="line"></div>
					<div class="line"></div>
					<div style="text-align: center;padding-top: 30px;padding-bottom: 50px;">
						<el-button @click="back()">取消</el-button>
						<el-button type="primary" @click="handleConfirm()":loading="loading">保存</el-button>
					</div>
				</el-tab-pane>
			</el-tabs>
			<!--标签页结束-->
		</div>
		<!--编辑、添加框结束-->
		<!--内容-->
		<div class="main" style="width: 1580px;" v-show="!handle">
			<!--标题-->
			<div class="top cf">
				<div class="topL fl"><span>零件查询</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="mainL fl" style="width: 150px;">
				<div class="line"></div>
				<!--tree-->
				<div class="treeOuter">
					<div class="treeTitle">系列列表</div>
					<div v-show = "seriesTag.length==0" style="color: #fff;padding: 30px;">暂无系列</div>
					<div class="treeNodeArr">
						<div v-for="item,index in seriesTag" @click="handleNodeClick(item)" :class="isActive==item.id?'active':''"><span class="el-icon-document"></span>{{item.name}}</div>
					</div>
				</div>
			</div>
			<div class="mainR fr" style="width: 1380px;">
				<div class="line"></div>
				<div class="dataTag">
					<!--零件操作-->
					<div class="handle">
						<div class="handleBtn fl">
							<el-button type="primary" size="small" @click="handleAdd()">新增零件</el-button>
							<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
						</div>
					</div>
					<!--零件筛选-->
					<div class="filtrateMain">
						<el-row style="text-align: center;">
							<el-col :span="4">
								<el-input v-model="filtrateData.name" placeholder="零件名称" class="inputWidth"></el-input>
							</el-col>
							<el-col :span="4">
								<el-select v-model="filtrateData.supplierId" placeholder="供应商" class="inputWidth">
									<el-option v-for="item in frimOptions" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="4">
								<el-select v-model="filtrateData.structureId" placeholder="零件结构" class="inputWidth">
									<el-option v-for="item in structureOptions" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="4">
								<el-select v-model="filtrateData.status" placeholder="选择状态" class="inputWidth">
									<el-option v-for="item in options" :key="item.id" :label="item.label" :value="item.status">
									</el-option>
								</el-select>
							</el-col>
							<el-col :span="4" style="line-height: 40px;">
								<el-button type="primary" size="mini" @click="handleSearch()">查询</el-button>
								<el-button type="warning" size="mini" @click="handleReset()">重置</el-button>
							</el-col>
						</el-row>
						<!--筛选结束-->
					</div>
					<!--零件列表-->
					<div class="tableData" style="text-align: center;">
						<el-table
							ref="multipleTable"
							:data="tableData"
							border
							@selection-change="handleSelectionChange"
							style="width: 100%;border-top: 1px solid #ddd;border-bottom: 1px solid #ddd;">
							<el-table-column type="selection">
							</el-table-column>
							<el-table-column type="index" width="60px" label="编号">
						   </el-table-column>
							<el-table-column prop="id" width="64px" label="零件Id">
						   </el-table-column>
							<el-table-column prop="name" label="零件名" width="190px">
							</el-table-column>
							<el-table-column prop="number" label="零件编号" width="190px">
							</el-table-column>
							<el-table-column prop="structureId" label="零件结构" width="80px">
								<template slot-scope="scope">
									<span>{{structureIdtoName(scope.row.structureId)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="seriesId" label="所属系列" width="130px">
								<template slot-scope="scope">
									<span>{{seriesIdtoName(scope.row.seriesId)}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="supplierId" label="供应商" width="120px">
								<template slot-scope="scope">
									<span>{{supplierIdtoName(scope.row.supplierId)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="状态">
								<template slot-scope="scope">
									<span>{{scope.row.status==1?"上架":"下架"}}</span>
								</template>
							</el-table-column>
							<el-table-column prop="price" label="价格">
							</el-table-column>
							<el-table-column label="缩略图" width="90px">
								<template slot-scope="scope">
									<img :src="scope.row.imgUrl" height="23px" alt="缩略图"/>
								</template>
							</el-table-column>
							<el-table-column prop="createTime" label="创建时间" width="95px">
								<template slot-scope="scope">
									<span>{{dataTimeFn(scope.row.createTime)}}</span>
								</template>
							</el-table-column>
							<el-table-column label="操作" width="120px">
								<template slot-scope="scope">
									<a href="javascript:void(0)" @click="handleDetails(scope.$index, scope.row)" style="color: #1ABC9C;">详情</a>
									<a href="javascript:void(0)" @click="handleEdit(scope.row)" style="color: #1ABC9C;">编辑</a>
									<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<!--零件列表结束-->
					<!--分页-->
					<div class="page">
						<el-pagination
							background
							:current-page="tableDataArr.currentPage"
							:page-sizes="[10,20,30,40]"
							:page-size="tableDataArr.pageSize"
							layout="total, sizes, prev, pager, next, jumper"
							:total="tableDataArr.totalSize"
					     	@current-change="handleCurrentChange"
					     	@size-change="handleSizeChange">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import treeView from './treeView'
import '../assets/css/style.css'
import SparkMD5 from 'spark-md5'
import navZcy from './nav'
export default {
	data() {
		return {
			loading: false,
			isActive: 0,
			seriesTag: [],
			handleTitle: '',        //操作框标题
			uploaderImg: {},		//上传图片实例
			uploaderFile: {},		//上传pak实例
			usr: '',				//OSS的accesskey值
			pwd: '',				//OSS的accessid值
			uploadFlieIsOk: false,  //上传pak时是否显示上传进度条
			responseData: '',		//上传pak进度条百分比
			uploadImgIsOk: false,	//上传图片时是否显示上传进度条
			thumbnailShow: false,	//上传完图片显示缩略图
			responseImgData: '',	//上传图片进度条百分比
			activeName: 'Tab1',		//标签页初始时显示页
			handle: false,			//点击编辑添加时显示标签页
			dialogVisible: false,	//零件详情是否显示
			dialogDetails: {		//零件详情内容
				sizeType: ["","",""],
				size: [0,0,0]
			},
			supplierVisible: false,
			supplierDetails: {		//零件详情内容
				name: ""
			},
			filtrateData: {},
			options: [{						//筛选上架下架状态
				id: 0,
				status: -1,
				label: '上架下架状态'
			},{
				id: 1,
				status: 1,
				label: '上架'
			}, {
				id: 2,
				status: 2,
				label: '下架'
			}],
			frimOptions: [],    	//企业下拉框参数
			structureOptions: [],   //结构下拉框
			sizeTypeOptions: [],    //零件尺寸的类型
			sizeArrlen: 0,
			tableDataArr: {			//分页
				currentPage: 1,
				pageSize: 10,
				totalSize: 0
			},
			tableData: [],			//零件列表参数
			multipleSelection: [],	//零件列表所选复选框
			dialogData: {},			//添加、编辑操作框参数
		}
	},
	methods: {
		//节点被选中
		handleNodeClick(data) {
			this.isActive = data.id
			this.filtrateData.seriesId = data.id
			sessionStorage.setItem('seriesId',data.id)
			this.tableDataArr.currentPage = 1
			this.queryPart()
		},
		//获取系列列表
		querySeries() {
			let url = "/lightApi/series/inuqirySeries/" + sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': {},'Fn': this.querySeriesFn,'vue':this})
		},
		querySeriesFn(data) {
			if(data.msg=="ok"){
				this.seriesTag = this.seriesTag.concat(data.data.items)
				let seriesId = 0;
				for (var i=0; i<this.seriesTag.length; i++) {
					if(this.seriesTag[i].id == parseInt(sessionStorage.getItem('seriesId'))){
						seriesId = parseInt(sessionStorage.getItem('seriesId'))
					}
				}
				if(!seriesId){
					seriesId = this.seriesTag[0].id
				}
				this.isActive = seriesId
				this.filtrateData.seriesId = seriesId
				sessionStorage.setItem('seriesId',seriesId)
				this.queryPart()
			}else{
				this.seriesTag = []
			}
		},
		seriesIdtoName(id) {
			for (let i=0; i<this.seriesTag.length; i++) {
				if(id==this.seriesTag[i].id){
					return this.seriesTag[i].name
				}
			}
			return '无';
		},
		//获取供应商列表
		querySupplier() {
			let url = "/lightApi/supplier/inquirySupplier/" + sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': {},'Fn': this.queryCompanyFn,'vue':this})
		},
		queryCompanyFn(data) {
			if(data.msg=="ok"){
				this.frimOptions = this.frimOptions.concat(data.data.items)
			}else{
				this.frimOptions = []
			}
		},
		supplierIdtoName(id) {
			for (let i=0; i<this.frimOptions.length; i++) {
				if(id==this.frimOptions[i].id){
					return this.frimOptions[i].name
				}
			}
			return '无';
		},
		//获取零件结构
		queryStructure() {
			let url = "/lightApi/structure/inquiryStructure/" + sessionStorage.getItem('sessionId')
			this.$store.dispatch('handleGet',{'url': url,'Fn': this.queryStructureFn,'vue':this})
		},
		queryStructureFn(data) {
			this.structureOptions = []
			if(data.msg=="ok"){
				this.structureOptions = this.structureOptions.concat(data.data.items)
			}
		},
		structureIdtoName(id) {
			for (let i=0; i<this.structureOptions.length; i++) {
				if(id==this.structureOptions[i].id){
					return this.structureOptions[i].name
				}
			}
			return '无';
		},
		//获取尺寸类型
		querySizeType() {
			let url = "/lightApi/sizeType/inquirySizeTypeById/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handleGet',{'url': url,'Fn': this.querySizeTypeFn,'vue':this})
		},
		querySizeTypeFn(data) {
			this.sizeTypeOptions = []
			if(data.msg=="ok"){
				this.sizeTypeOptions = this.sizeTypeOptions.concat(data.data.items)
			}
		},
		sizeTypeChange(key) {
			let sizeArr;
			for (let i=0,len=this.sizeTypeOptions.length; i<len; i++) {
				if(key==this.sizeTypeOptions[i].id){
					sizeArr = this.sizeTypeOptions[i].sizeType
					this.sizeArrlen = sizeArr.length
				}
			}
			return sizeArr;
		},
		sizeSelceChangeFn(key) {
			this.dialogData.sizeType = this.sizeTypeChange(key)
			this.dialogData.size=[]
			for (var i = 0; i < this.dialogData.sizeType.length; i++) {
				this.dialogData.size.push('')
			}
		},
//		查询零件列表数据
		queryPart() {
			if(this.filtrateData.supplierId){
				this.filtrateData.supplier=""
			}
			let data = {
				name: this.filtrateData.name,//产品名
				seriesId: this.filtrateData.seriesId,
				supplierId: this.filtrateData.supplierId,		//供应商Id
				status: this.filtrateData.status==-1?0:this.filtrateData.status,
				structureId: this.filtrateData.structureId,
				currentPage: this.tableDataArr.currentPage,
				pageSize: this.tableDataArr.pageSize
			}
			let url = "/lightApi/component/inquiryComponent/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.queryPartFn,'vue':this})
		},
		queryPartFn(data) {
			if(data.msg=="ok"){
				this.tableDataArr = data.data
				this.tableData = this.tableDataArr.items
				console.log(this.tableData)
			}else{
				this.tableDataArr={
					currentPage: 1,
					pageSize: 10,
					totalSize: 0
				}
				this.tableData = []
			}
		},
		getsupplierDetail(row) {
			this.supplierDetails={		//供应商详情内容
				name: row.name,
				supplier: []
			}
			for(let i=0,len=this.frimOptions.length; i<len; i++){
				for(let j=0,lenS=row.supplierId.length; j<lenS; j++){
					if(row.supplierId[j]==this.frimOptions[i].id){
						this.supplierDetails.supplier.push(this.frimOptions[i].name)
						break;
					}
				}
			}
			this.supplierVisible=true
		},
		//筛选查询
		handleSearch() {
			this.tableDataArr.currentPage = 1
			this.queryPart()
		},
		//重置筛选
		handleReset() {
			this.filtrateData = {}
		},

		//文件直传OSS
		uploadFile(){
	    	var vue = this;
	    	var policyText = {
			    "expiration": "2030-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
			    "conditions": [
			    	["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
			    ]
			};

			var accessid= this.usr;
			var accesskey= this.pwd;
			var host = 'http://zcvrstorage.oss-cn-shenzhen.aliyuncs.com';

			var policyBase64 = Base64.encode(JSON.stringify(policyText))
			var message = policyBase64
			var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true }) ;
			var signature = Crypto.util.bytesToBase64(bytes);
			var filePath = ''
			this.uploaderFile = new plupload.Uploader({
				runtimes : 'html5,flash,silverlight,html4',
				browse_button : 'postfiles',
			    //runtimes : 'flash',
				container: document.getElementById('container'),
				flash_swf_url : 'static/plupload-2.1.2/js/Moxie.swf',
				silverlight_xap_url : 'static/plupload-2.1.2/js/Moxie.xap',
				filters: {
					mime_types : [ //只允许pak文件
						{ title : "Pak files", extensions : "pak" },
					],
				},

			    url : host,

				multipart_params: {
					'Filename': '${filename}',
			        'key' : '${filename}',
					'policy': policyBase64,
			        'OSSAccessKeyId': accessid,
			        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
					'signature': signature,
				},

				init: {
					FilesAdded: function(up, files) {
						plupload.each(files, function(file) {
							vue.dialogData.ue4Name = file.name.replace(".pak","")
							var oDate = new Date()
							let pakName = oDate.getTime()+".pak"
							filePath = 'LightFile/pak/'+oDate.getFullYear()+"/"+(oDate.getMonth()+1)+"/"+oDate.getDate()+"/"+pakName
							let	multipart_paramsb=  {
								'Filename': '${filename}',
						        'key' : filePath,
								'policy': policyBase64,
						        'OSSAccessKeyId': accessid,
						        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
								'signature': signature
							}
							vue.uploaderFile.setOption("multipart_params",multipart_paramsb);
							vue.dialogData.pakUrlName = pakName
							vue.responseData = ''
							$('.progress-bar').css('width','0px')
			            	$('.progress-bar').attr('aria-valuenow', '0')
							vue.uploadFlieIsOk = true
							vue.uploaderFile.start();
						});
					},
					UploadProgress: function(up, file) {
			            vue.responseData = file.percent + "%"
			            $('.progress-bar').css('width',2.4*file.percent+'px')
			            $('.progress-bar').attr('aria-valuenow', file.percent)
					},
					FileUploaded: function(up, file, info) {
			            if (info.status >= 200 || info.status < 200){
			            	vue.hashMd5(file.getNative(),'pak')
			            	vue.responseData = '成功'
							vue.dialogData.pakUrl = 'http://zcvrstorage.oss-cn-shenzhen.aliyuncs.com/'+filePath
						}else{
			            	vue.responseData = info.response
			            	vue.dialogData.pakUrl = ''
			            	$('.progress-bar').css('width','0px')
			            	$('.progress-bar').attr('aria-valuenow', '0')
			            }
					},

					Error: function(up, err) {
						vue.$message.error(err.message)
					}
				}
			});
	    },
		//图片直传OSS
		uploadImg(){
	    	var vue = this;
	    	var policyText = {
			    "expiration": "2030-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
			    "conditions": [
			    	["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
			    ]
			};

			var accessid= this.usr;
			var accesskey= this.pwd;
			var host = 'http://zcvrstorage.oss-cn-shenzhen.aliyuncs.com';

			var policyBase64 = Base64.encode(JSON.stringify(policyText))
			var message = policyBase64
			var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true }) ;
			var signature = Crypto.util.bytesToBase64(bytes);
			var filePath = ''
			this.uploaderImg = new plupload.Uploader({
				runtimes : 'html5,flash,silverlight,html4',
				browse_button : 'postImg',
			    //runtimes : 'flash',
				container: document.getElementById('containerImg'),
				flash_swf_url : 'static/plupload-2.1.2/js/Moxie.swf',
				silverlight_xap_url : 'static/plupload-2.1.2/js/Moxie.xap',
				filters: {
					mime_types : [ //只允许上传图片和zip文件
						{ title : "Image files", extensions : "jpg,png" },
					],
					max_file_size : '1024kb',
				},

			    url : host,

				multipart_params: {
					'Filename': '${filename}',
			        'key' : '${filename}',
					'policy': policyBase64,
			        'OSSAccessKeyId': accessid,
			        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
					'signature': signature,
				},

				init: {
					FilesAdded: function(up, files) {
						plupload.each(files, function(file) {
							var oDate = new Date()
							let type = file.name.split(".")
							let pakName = oDate.getTime()+"."+type[type.length-1]
							filePath = 'LightFile/photo/'+oDate.getFullYear()+"/"+(oDate.getMonth()+1)+"/"+oDate.getDate()+"/"+pakName
							let	multipart_paramsb=  {
								'Filename': '${filename}',
						        'key' : filePath,
								'policy': policyBase64,
						        'OSSAccessKeyId': accessid,
						        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
								'signature': signature
							}
							vue.uploaderImg.setOption("multipart_params",multipart_paramsb);
							vue.dialogData.imgUrlName = pakName
							vue.responseImgData = ''
							$('.progressImg-bar').css('width','0px')
			            	$('.progressImg-bar').attr('aria-valuenow', '0')
							vue.uploadImgIsOk = true
							vue.uploaderImg.start();
						});
					},
					UploadProgress: function(up, file) {
			            vue.responseImgData = file.percent + "%"
			            $('.progressImg-bar').css('width',2.4*file.percent+'px')
			            $('.progressImg-bar').attr('aria-valuenow', file.percent)
					},
					FileUploaded: function(up, file, info) {
			            if (info.status >= 200 || info.status < 200){
			            	vue.thumbnailShow = true
			            	vue.uploadImgIsOk = false
			            	vue.hashMd5(file.getNative(),'img')
			            	vue.responseImgData = '成功'
							vue.dialogData.imgUrl = 'http://zcvrstorage.oss-cn-shenzhen.aliyuncs.com/'+filePath
						}else{
			            	vue.responseImgData = info.response
			            	vue.dialogData.imgUrl = ''
			            	$('.progressImg-bar').css('width','0px')
			            	$('.progressImg-bar').attr('aria-valuenow', '0')
			            }
					},

					Error: function(up, err) {
//						console.log(err)
						if(err.message == 'File size error.'){
							vue.$message.error('上传头像图片大小不能超过 1MB!');
						}else{
							vue.$message.error(err.message);
						}

					}
				}
			});
	    },
	    //获取OSS密令
	    getOss: function(){
	    	this.$http.get("/lightApi/oss/getOssMsg/" + sessionStorage.getItem('sessionId'),{},{emulateJson:true}).then(
				(succeed)=>{
//					console.log(succeed)
					if(succeed.body.msg=="ok"){
						this.usr=succeed.body.data.accessid;
						this.pwd=succeed.body.data.accesskey;
						this.uploadFile()
						this.uploaderFile.init()
						this.uploadImg()
						this.uploaderImg.init()
					}else{
						if(succeed.body.msg=='该SessionId不存在'||succeed.body.msg=='该SessionId已经超时'){
//							this.sessionTimeout(succeed.body.msg)
						}
					}
				}
			)
	    },
		//计算文件的MD5
		hashMd5(item,classify){
	    	var vue = this
		   	var fileReader = new FileReader(),
	        blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
	        file = item,
	        chunkSize = 2097152,
	        chunks = Math.ceil(file.size / chunkSize),
	        currentChunk = 0,
	        spark = new SparkMD5();
		    fileReader.onload = function(e) {
		        spark.appendBinary(e.target.result); // append binary string
		        currentChunk++;

		        if (currentChunk < chunks) {
		            loadNext();
		        }else {
		        	//拼接上传路径
		        	if(classify=='pak'){
		        		vue.dialogData.pakMd5 = spark.end()
		        	}else{
		        		vue.dialogData.imgMd5 = spark.end()
		        	}
		        }
		    };
		    function loadNext() {
		        var start = currentChunk * chunkSize,
		            end = start + chunkSize >= file.size ? file.size : start + chunkSize;

		        fileReader.readAsBinaryString(blobSlice.call(file, start, end));
		    };
		    loadNext();
		},
		refresh() {
			location.reload();
		},
		//新添零件表
		handleAdd() {
			this.loading = false
			this.handleTitle = '添加零件'
			this.activeName = 'Tab1'
			this.uploadFlieIsOk = false
			this.responseData = ''
            $('.progress-bar').css('width','0px')
			this.dialogData = {
				name: "",
				ue4Name: "",
				number: "",
				price: "",
				size: [],
				length: '',
				width: '',
				height: '',
				sizeTypeId: this.sizeTypeOptions[0].id,
				sizeType: this.sizeTypeChange(this.sizeTypeOptions[0].id),
				supplierId: '',
				structureId: '',
				status: true,
				description: "",
				pakUrlName: '',
				pakUrl: '',
				pakMd5: "",
				imgUrlName: '',
				imgUrl: '',
				imgMd5: "",
				purchaseLink: "",
				wattage: ""
			}
			for (var i = 0; i < this.dialogData.sizeType.length; i++) {
				this.dialogData.size.push('')
			}
			this.handle = true;
		},
		//编辑、添加时点击取消
		back() {
			this.handle = false;
		},
		//编辑零件表
		handleEdit: function(row,index) {
			this.loading = false
			this.handleTitle = '编辑零件'
			this.activeName = 'Tab1'
			let fileName = ''
			if(row.pakUrl){
				fileName = row.pakUrl.split("/")
				fileName = fileName[fileName.length-1]
				this.uploadFlieIsOk = true
				this.responseData = '成功'
	            $('.progress-bar').css('width','240px')
	            $('.progress-bar').attr('aria-valuenow', '100')
			}
			let imgName = ''
			if(row.imgUrl){
				imgName = row.imgUrl.split("/")
				imgName = imgName[imgName.length-1]
				this.thumbnailShow = true
			}
			this.dialogData={
				id: row.id,
				name: row.name,
				ue4Name: row.ue4Name,
				number: row.number,
				price: row.price,
				size: row.size,
				sizeTypeId: row.sizeTypeId,
				sizeType: this.sizeTypeChange(row.sizeTypeId),
				supplierId: row.supplierId,
				structureId: row.structureId,
				status: row.status==1?true:false,
				description: row.description,
				pakUrlName: fileName,
				pakUrl: row.pakUrl,
				pakMd5: row.pakMd5,
				imgUrlName: imgName,
				imgUrl: row.imgUrl,
				imgMd5: row.imgMd5,
				purchaseLink: row.purchaseLink,
				wattage: row.wattage
			}
			for (var i = 0; i < this.dialogData.sizeType.length; i++) {
				if(this.dialogData.size.length-1<i){
					this.dialogData.size.push('')
				}
			}
			this.handle = true;
		},
		//浅复制对象参数
		copyObj: function(obj){
		    var newobj = {};
		    for ( var attr in obj) {
		        newobj[attr] = obj[attr];
		    }
		    return newobj;
		},
		handleConfirm: function(){
			this.loading = true
			if(this.dialogData.supplierId){
				let url = "" //接口url
				var oData = {//接口参数
					name: this.dialogData.name,
					ue4Name: this.dialogData.ue4Name,
					number: this.dialogData.number,
					price: parseFloat(this.dialogData.price),
					size: [],
					sizeTypeId: this.dialogData.sizeTypeId,
					supplierId: this.dialogData.supplierId?this.dialogData.supplierId:0,
					structureId: this.dialogData.structureId?this.dialogData.structureId:0,
					seriesId: this.filtrateData.seriesId,
					status: this.dialogData.status?1:2,
					imgUrl: this.dialogData.imgUrl,
					imgMd5: this.dialogData.imgMd5,
					pakUrl: this.dialogData.pakUrl,
					pakMd5: this.dialogData.pakMd5,
					description: this.dialogData.description,
					purchaseLink: this.dialogData.purchaseLink,
					wattage: this.dialogData.wattage
				}
				if($('.sizeType input')){
					for (var i = 0; i < $('.sizeType input').length; i++) {
						if($('.sizeType input')[i].value){
							oData.size.push(parseFloat(parseFloat($('.sizeType input')[i].value).toFixed(2)))
						}
					}
				}
				if(this.dialogData.id||this.dialogData.id==-1){//编辑接口
					url = "/lightApi/component/updateComponent/" + sessionStorage.getItem('sessionId')
					oData.id = this.dialogData.id
				}else{//添加接口
					url = "/lightApi/component/createComponent/" + sessionStorage.getItem('sessionId')
				}
				this.$store.dispatch('handlePost',{'url': url, 'data': oData,'Fn': this.handleConfirmFn,'vue':this})
			}else{
				this.loading = false
				this.$message({
					type: 'error',
					message: '请选供应商'
				});
			}
		},
		handleConfirmFn(data) {
			if(data.msg=="ok"){
				this.handle = false;
				this.$message({
					type: 'success',
					message: '保存成功'
				});
				this.queryPart()
			}else{
			    this.loading = false
				if(data.msg!='该SessionId不存在'&&data.msg!='该SessionId已经超时'){
					this.$message({
						type: 'error',
						message: data.msg
					});
				}
			}
		},
		//零件详情
		handleDetails(index, row) {
			this.dialogDetails = row
			this.dialogDetails.sizeType = this.sizeTypeChange(this.dialogDetails.sizeTypeId)
			this.dialogVisible = true
		},
		//点击弹出框x关闭弹出框
		handleClose: function(done) {
			done();
		},
		//点击零件列表复选框
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除零件
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该零件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "/lightApi/component/deleteComponent/"+sessionStorage.getItem('sessionId')+"/"+id
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}
		},
		handleDeleteFn(data) {
			if(data.msg=="ok"){
				this.queryPart()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				if(data.msg=='该SessionId不存在'&&data.msg=='该SessionId已经超时'){
					this.$message({
						type: 'error',
						message: data.msg
					});
				}
			}
		},
        //点击页数
		handleCurrentChange(cur) {
			this.tableDataArr.currentPage = cur
			this.queryPart()
		},
		//点击改变显示条目
		handleSizeChange(size) {
			this.tableDataArr.pageSize = size
			this.queryPart()
		},
		//时间格式化
		dataTimeFn: function(time){
	   		var oDate
	   		if(time!=""){
				if(typeof(time)=='string'&&time.indexOf(' +0800 CST')!=-1){
					time = time.split(' +0800 CST')[0]
				}
	   			oDate = new Date(time)
	   		}else{
	   			oDate = new Date()
	   		}

	  		var mon = oDate.getMonth()+1
	  		var d = oDate.getDate()
	  		if(mon<10){
	  			mon="0"+mon
	  		}
	  		if(d<10){
	  			d="0"+d
	  		}
	  		return oDate.getFullYear()+"-"+mon+"-"+d
	   	}
	},
	created() {
		this.querySupplier()
		this.querySizeType()
		this.queryStructure()
	},
	mounted() {
		this.getOss()
		this.querySeries()
	},
	components: {
		navZcy,
		treeView
	}
}
</script>
<style type="text/css">
	.tabMain a{
		text-decoration: none;
		color: #333;
		font-size: 14px;
	}
	.tabMain a.actice{
		color: #1ABC9C;
	}
	.inputSmall .el-input__inner{
		padding: 0 5px;
		text-align: center;
	}
</style>
<style scoped>
	.component{
		padding: 0 30px;
	}
	.component a{
		text-decoration: none;
		color: #666;
	}
	.component .el-icon-check{
		font-weight: bold;
		color: green;
	}
	.component .active{
		color: #1ABC9C;
	}
	dl dt{
		width: 84px;
	}
	dl{
		margin: 20px 0;
	}

	.dialogMain .fl dl dt {
		width: 94px;
	}
	.dialogMain .fr dl dt{
	    width: 70px;
	}
	.sizeType{
		text-align: left;
		width: 260px;
	}
	.inputSmall{
		width: 90%;
	}
	/*.inputSpan{
		padding: 0 5px;
	}*/
	.classify {
		border-bottom: 1px dashed #ccc;
		line-height: 50px;
		margin: 0 10px;
		padding: 0 10px;
	}
	.classifyArr{
		display: block;
		color: #666;
		padding: 0 10px;
		border-right: 1px dashed #ccc;
		/*float: left;*/
		/*position: relative;*/
	}
	.closeOuter{
		position: relative;
		width: 20px;
		/*display: none;*/
	}
	.classifyClose{
		font-size: 16px;
		color: #000;
		position: absolute;
		top: -20px;
		right: 0px;
	}
	.taxon {
		font-weight: bold;
	}

	.className,.taxon {
		color: #666;
		display: inline-block;
		padding: 0 10px;
	}
	.className a,.taxon a{
		color: #333;
		font-size: 14px;
	}
	.className.active{
		color: #1ABC9C;
	}
	.treeOuter{
		background: #267cb7;
		width: 100%;
		padding: 20px 20px 20px 10px;
	}
	.treeTitle{
		display: block;
		color: goldenrod;
	}
	.treeNodeArr {
		padding: 10px 10px 0 10px;
		color: #fff;
		cursor: pointer;
	}
	.treeNodeArr>div {
		padding-bottom: 5px;
	}
	.treeNodeArr .active{
		color: goldenrod;
	}
	.containerOuter{
		height: 400px;
		width: 240px;
		margin: 0 auto;
	}
	.containerOuter .thumbnail{
		margin-top: 15px;
		width: 100%;
		overflow: hidden;
	}
	.containerOuter .thumbnail img{
    	border: 1px dashed #ddd;
	}
	#container{
		text-align: center;
		display: inline-block;
		margin-top: 15px;
	}
	#ossfile{
		margin-top: 20px;
	}
	.progress,.progressImg{
		margin-top:2px;
	    width: 240px;
	    height: 14px;
	    margin-bottom: 10px;
	    overflow: hidden;
	    background-color: #f5f5f5;
	    border-radius: 4px;
	    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
	    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
	}
	.progress-bar,.progressImg-bar{
		background-color: rgb(92, 184, 92);
		background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.14902) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.14902) 50%, rgba(255, 255, 255, 0.14902) 75%, transparent 75%, transparent);
		background-size: 40px 40px;
		box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;
		box-sizing: border-box;
		color: rgb(255, 255, 255);
		display: block;
		float: left;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		transition-delay: 0s;
		transition-duration: 0.6s;
		transition-property: width;
		transition-timing-function: ease;
		width: 266.188px;
	}
	.frimOptionsOuter{
		max-height: 90px;
		overflow-y: auto;
	}
	.addFrim{
	    font-size: 20px;
	    background-color: #1ABC9C;
	    border-color: #1ABC9C;
	    color: #fff;
	    padding: 6px;
	    border-radius: 5px;
	    margin-left: 10px;
	}
	.delFrim{
		margin-left: 10px;
	    font-size: 16px;
	    color: #aaa;
	}
	.moreFrim{
		color: #666;
	    border: 1px solid #666;
	    border-radius: 50%;
	    padding: 3px;
	    float: right;
	    font-size: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/part.vue